(function () {
  'use strict';

  const STORAGE_KEY = 'kk_meta_attribution_v1';
  const SESSION_SYNC_KEY = 'kk_meta_attribution_synced_v1';

  // Attribution čuvamo 30 dana od posljednjeg Meta klika
  const ATTRIBUTION_DAYS = 30;
  const ATTRIBUTION_WINDOW =
    ATTRIBUTION_DAYS * 24 * 60 * 60 * 1000;

  const now = Date.now();
  const url = new URL(window.location.href);

  // Meta / UTM parametri
  const campaignId = url.searchParams.get('meta_campaign_id');
  const campaignName = url.searchParams.get('utm_campaign');
  const adsetId = url.searchParams.get('meta_adset_id');
  const adId = url.searchParams.get('meta_ad_id');
  const source = url.searchParams.get('utm_source');

  let attribution = {};

  // -------------------------
  // UČITAVANJE POSTOJEĆIH PODATAKA
  // -------------------------

  try {
    attribution = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '{}'
    );
  } catch (e) {
    attribution = {};
  }

  // Ako je posljednji Meta klik stariji od 30 dana,
  // počinjemo novu attribution sesiju
  if (
    attribution.last &&
    attribution.last.timestamp &&
    (now - attribution.last.timestamp) > ATTRIBUTION_WINDOW
  ) {
    attribution = {};
    localStorage.removeItem(STORAGE_KEY);
  }

  // -------------------------
  // NOVI META KLIK
  // -------------------------

  if (campaignId) {

    const currentClick = {
      campaign_id: campaignId,
      campaign_name: campaignName || '',
      adset_id: adsetId || '',
      ad_id: adId || '',
      source: source || 'meta',
      landing_page: window.location.pathname,
      clicked_at: new Date(now).toISOString(),
      timestamp: now
    };

    // FIRST CLICK se postavlja samo prvi put
    if (!attribution.first) {
      attribution.first = currentClick;
    }

    // LAST CLICK se mijenja pri svakom novom Meta kliku
    attribution.last = currentClick;

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(attribution)
      );
    } catch (e) {
      console.warn('Meta attribution storage failed.', e);
    }

    // Novi klik znači da Shopify treba ponovo
    // da dobije najnovije attribution podatke
    sessionStorage.removeItem(SESSION_SYNC_KEY);

    // -------------------------
    // ČIŠĆENJE URL-a
    // -------------------------

    const trackingParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'meta_campaign_id',
      'meta_adset_id',
      'meta_ad_id'
    ];

    trackingParams.forEach(function (param) {
      url.searchParams.delete(param);
    });

    // Čuvamo druge važne parametre poput ?variant=
    const cleanUrl =
      url.pathname +
      (url.search ? url.search : '') +
      url.hash;

    window.history.replaceState(
      window.history.state,
      document.title,
      cleanUrl
    );
  }

  // -------------------------
  // SLANJE PODATAKA SHOPIFYJU
  // -------------------------

  function syncAttributionToShopify() {

    if (!attribution.first || !attribution.last) {
      return;
    }

    const first = attribution.first;
    const last = attribution.last;

    // Sprečava nepotrebne ponovljene zahtjeve
    // tokom iste browser sesije
    const signature = [
      first.campaign_id,
      first.clicked_at,
      last.campaign_id,
      last.clicked_at
    ].join('|');

    if (
      sessionStorage.getItem(SESSION_SYNC_KEY) === signature
    ) {
      return;
    }

    const attributes = {

      // FIRST CLICK
      '__meta_first_campaign_id':
        first.campaign_id || '',

      '__meta_first_campaign':
        first.campaign_name || '',

      '__meta_first_adset_id':
        first.adset_id || '',

      '__meta_first_ad_id':
        first.ad_id || '',

      '__meta_first_source':
        first.source || '',

      '__meta_first_product':
        first.landing_page || '',

      '__meta_first_click':
        first.clicked_at || '',


      // LAST CLICK
      '__meta_last_campaign_id':
        last.campaign_id || '',

      '__meta_last_campaign':
        last.campaign_name || '',

      '__meta_last_adset_id':
        last.adset_id || '',

      '__meta_last_ad_id':
        last.ad_id || '',

      '__meta_last_source':
        last.source || '',

      '__meta_last_product':
        last.landing_page || '',

      '__meta_last_click':
        last.clicked_at || ''
    };

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      credentials: 'same-origin',

      body: JSON.stringify({
        attributes: attributes
      })
    })
      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Shopify attribution sync failed: ' +
            response.status
          );
        }

        sessionStorage.setItem(
          SESSION_SYNC_KEY,
          signature
        );
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  // Asinhrono - ne blokira prikaz stranice
  syncAttributionToShopify();


  // -------------------------
  // DEBUG FUNKCIJA
  // -------------------------

  window.KKMetaAttribution = {

    get: function () {
      try {
        return JSON.parse(
          localStorage.getItem(STORAGE_KEY) || '{}'
        );
      } catch (e) {
        return {};
      }
    },

    clear: function () {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(SESSION_SYNC_KEY);

      console.log(
        'Meta attribution podaci su obrisani.'
      );
    },

    sync: function () {
      syncAttributionToShopify();
    }

  };

})();